import { NavLink, useLocation } from "react-router-dom";

export type ReproductionArchiveKind = "breeding" | "births";

type Area = "breeding" | "births" | "archive";

type Props = {
  area: Area;
  /** Used on the archive page to point „Aktywne” at the right list. */
  archiveKind?: ReproductionArchiveKind;
};

function archiveHref(kind: ReproductionArchiveKind): string {
  return `/reproduction/archive?kind=${kind}`;
}

export function BirthsSubnav({ area, archiveKind = "births" }: Props) {
  const location = useLocation();
  const kind: ReproductionArchiveKind =
    area === "breeding" ? "breeding" : area === "archive" ? archiveKind : "births";
  const activeTo = kind === "breeding" ? "/reproduction/breeding" : "/reproduction/births";
  const archiveTo = archiveHref(kind);
  const onArchive = location.pathname === "/reproduction/archive";

  const items: { to: string; label: string; end: boolean; archive?: boolean }[] = [
    { to: activeTo, label: "Aktywne", end: true },
    { to: archiveTo, label: "Archiwum", end: true, archive: true },
  ];

  return (
    <nav className="subnav" aria-label="Rozród">
      {items.map((item) => (
        <NavLink
          key={`${item.label}-${item.to}`}
          to={item.to}
          end={item.end}
          className={({ isActive }) => {
            const active = item.archive ? onArchive : isActive && !onArchive;
            return active ? "subnav__link subnav__link--active" : "subnav__link";
          }}
        >
          {item.label}
        </NavLink>
      ))}
    </nav>
  );
}
